import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent
} from "@softline/dynamic";
import { ProduktgruppeListView } from "./list-view/produktgruppe.list-view";

export const produktgruppeFieldOk: FieldOkConfig = {
  name: 'produktgruppe',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{produktgruppe}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: ProduktgruppeListView,
      sort: {
        properties: [
          {property: 'id', title: 'Erfassungszeitpunkt'},
          {property: 'bezeichnung', title: 'Bezeichung'},
        ]
      }
    }
  }
  ]
};
export const produktgruppeMultiselectFieldOk: FieldOkConfig = {
  name: 'produktgruppe',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{produktgruppe}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkMultiselectListViewComponent,
    title: 'Auswahl',
    config: {
      component: ProduktgruppeListView,
      sort: {
        properties: [
          {property: 'id', title: 'Erfassungszeitpunkt'},
          {property: 'bezeichnung', title: 'Bezeichung'},
        ]
      }
    }
  }
  ]
};

export const produktgruppeQueryFieldOk: FieldOkConfig = {
  name: 'produktgruppe',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{produktgruppe}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: QueryFieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: ProduktgruppeListView,
      sort: {
        properties: [
          {property: 'id', title: 'Erfassungszeitpunkt'},
          {property: 'bezeichnung', title: 'Bezeichung'},
        ]
      }
    }
  }
  ]
};
